export enum ErrorSeverityEnum {
  Low = 1,
  Medium = 2,
  High = 3
}
